// Supabase read/write for site settings (table: "settings").
// Company contact info is stored as one row: id = 'contact', data = jsonb.
import { supabase } from "../supabase/client";

// Fallback used before an admin has saved anything (and by public pages so the
// site still renders if the backend is briefly unreachable).
export const DEFAULT_CONTACT = {
  offices: [
    {
      title: "Head Office — Pakistan",
      address: "20 Km Ferozepur Road, Youhanabad, Lahore, Pakistan",
      email: "info@softwoodtextiles.com",
      phone: "+92-42-35951191/92",
    },
    {
      title: "France Office",
      address: "20 Rue Sandro Botticelli, 68260 Kingersheim, France",
      email: "arman@softwoodtextiles.com",
      phone: "+33-610691868",
    },
  ],
  careersEmail: "careers@softwoodtextiles.com",
  social: {
    facebook: "https://www.facebook.com/Softwoodtextiles/",
    linkedin: "https://www.linkedin.com/company/softwood",
  },
};

export async function getContactSettings() {
  const { data, error } = await supabase
    .from("settings")
    .select("data")
    .eq("id", "contact")
    .maybeSingle();
  if (error) throw error;
  return data?.data || DEFAULT_CONTACT;
}

export async function saveContactSettings(payload) {
  const { error } = await supabase
    .from("settings")
    .upsert({ id: "contact", data: payload });
  if (error) throw error;
}
